import AppLayout from "../components/common/AppLayout";

export default function CuentasCobrarPage() {
    return (
        <AppLayout title="Cuentas por cobrar">
            <div className="card-panel">
                <h3>Módulo en construcción</h3>
                <p>Aquí irá la gestión de cuentas por cobrar, pagos parciales y vencimientos.</p>
            </div>
        </AppLayout>
    );
}